export const cardsData = [
  {
    index: 1,
    cardColor1: "cyan",
    cardColor2: "blue",
    title: "Don't Make Them Wait!",
    description: "Save 10% on First Order",
    imageUrl:
      "https://res.cloudinary.com/dvjbswt50/image/upload/v1717320243/spc/pngwing.com_ayza5i.png",
  },
  {
    index: 2,
    cardColor1: "purple",
    cardColor2: "blue",
    title: "Pamper Your Pet",
    description: "Groom with Care",
    imageUrl:
      "https://res.cloudinary.com/dvjbswt50/image/upload/v1717350152/spc/pngwing.com_3_rdeozq.png",
  },
  {
    index: 3,
    cardColor1: "pink",
    cardColor2: "yellow",
    title: "Nutritious Bites",
    description: " For Happy, Healthy Pets",
    imageUrl:
      "https://res.cloudinary.com/dvjbswt50/image/upload/v1717350377/spc/pngwing.com_4_dy14ag.png",
  },
];
